(function () {
  'use strict';

  function initPopups() {
    document.querySelectorAll('[data-store-credit-popup-trigger]').forEach(function (trigger) {
      if (trigger.dataset.bound) return;
      trigger.dataset.bound = '1';
      trigger.addEventListener('click', function () {
        var container = trigger.parentElement;
        var popup = container.querySelector('[data-store-credit-popup]');
        if (popup && popup.showModal) popup.showModal();
      });
    });

    document.querySelectorAll('[data-store-credit-popup-close]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var dialog = btn.closest('dialog');
        if (dialog) dialog.close();
      });
    });

    document.querySelectorAll('[data-store-credit-popup]').forEach(function (dialog) {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = '1';
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
    });
  }

  function tryFetchBalance() {
    // Wait for Rise.ai globals to be available
    if (!window.RiseStoreFront || !window.RiseStoreFront.customer) {
      console.log('[Store Credit] RiseStoreFront not ready, retrying...');
      return false;
    }

    var customer = window.RiseStoreFront.customer;
    var giftCardId = customer.gift_card_id;
    var loyaltyCardId = customer.loyalty_card_id || customer.LoyaltyCardId;
    var email = customer.email;
    var shopUrl = (window.RiseStoreFront.shop && window.RiseStoreFront.shop.shop_url) || window.Shopify.shop;

    console.log('[Store Credit] Rise customer found — gift_card_id:', giftCardId, 'loyalty_card_id:', loyaltyCardId);

    if (!giftCardId && !loyaltyCardId) {
      console.log('[Store Credit] No gift card or loyalty card ID found');
      return true;
    }

    // Try Rise.ai's known API endpoints via app proxy
    var endpoints = [
      '/apps/rise-ai/api/v2/gift-cards?customer_email=' + encodeURIComponent(email),
      '/apps/rise-ai/api/v2/gift-cards/' + giftCardId,
      '/apps/rise-ai/api/v2/loyalty/' + loyaltyCardId,
      '/apps/rise-ai/api/gift_cards?email=' + encodeURIComponent(email),
      '/apps/rise-ai/gift_card_balance?gift_card_id=' + giftCardId,
      '/apps/rise-ai/loyalty/balance?email=' + encodeURIComponent(email),
      '/apps/rise-ai/checkbalance?email=' + encodeURIComponent(email)
    ];

    endpoints.forEach(function (url) {
      fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          console.log('[Store Credit] ' + url + ' → ' + res.status);
          if (!res.ok) return null;
          var ct = res.headers.get('content-type') || '';
          if (ct.indexOf('json') !== -1) return res.json();
          return res.text().then(function (t) {
            try { return JSON.parse(t); } catch (e) { return t; }
          });
        })
        .then(function (data) {
          if (!data) return;
          console.log('[Store Credit] ' + url + ' response:', data);
          var balance = extractBalance(data);
          if (balance > 0) applyBalance(balance);
        })
        .catch(function (e) {
          console.log('[Store Credit] ' + url + ' error:', e.message);
        });
    });

    // Also try Rise.ai's external API (may work if CORS is configured)
    var riseApiUrls = [
      'https://application.rise-ai.com/v2/gift-cards/?customer_id=' + customer.id + '&shop_url=' + shopUrl,
      'https://application.rise-ai.com/v2/gift-cards/' + giftCardId + '?shop_url=' + shopUrl
    ];

    riseApiUrls.forEach(function (url) {
      fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          console.log('[Store Credit] Rise API ' + url.split('?')[0] + ' → ' + res.status);
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (data) {
          if (!data) return;
          console.log('[Store Credit] Rise API response:', data);
          var balance = extractBalance(data);
          if (balance > 0) applyBalance(balance);
        })
        .catch(function () {});
    });

    return true;
  }

  function extractBalance(data) {
    if (!data || typeof data === 'string') return 0;

    // Direct properties
    var keys = ['balance', 'total_balance', 'credit_balance', 'store_credit', 'amount', 'value'];
    for (var i = 0; i < keys.length; i++) {
      if (data[keys[i]] && parseFloat(data[keys[i]]) > 0) return parseFloat(data[keys[i]]);
    }

    // Nested in common wrappers
    var wrappers = ['gift_card', 'data', 'loyalty', 'customer', 'result', 'card'];
    for (var w = 0; w < wrappers.length; w++) {
      if (data[wrappers[w]] && typeof data[wrappers[w]] === 'object') {
        for (var k = 0; k < keys.length; k++) {
          if (data[wrappers[w]][keys[k]] && parseFloat(data[wrappers[w]][keys[k]]) > 0) {
            return parseFloat(data[wrappers[w]][keys[k]]);
          }
        }
      }
    }

    // Array of gift cards — sum balances
    if (Array.isArray(data)) {
      var total = 0;
      data.forEach(function (item) { total += extractBalance(item); });
      return total;
    }
    if (Array.isArray(data.gift_cards)) {
      var sum = 0;
      data.gift_cards.forEach(function (gc) { sum += extractBalance(gc); });
      return sum;
    }

    return 0;
  }

  function applyBalance(balance) {
    var formatted = '$' + parseFloat(balance).toFixed(2);
    console.log('[Store Credit] Applying balance:', formatted);

    document.querySelectorAll('[data-store-credit-msg]').forEach(function (el) {
      var icon = el.querySelector('svg');
      if (icon) {
        el.textContent = '';
        el.appendChild(icon);
        el.appendChild(document.createTextNode(' You have ' + formatted + ' in store credits'));
      } else {
        el.textContent = 'You have ' + formatted + ' in store credits';
      }
    });

    document.querySelectorAll('[data-store-credit-balance-row]').forEach(function (row) {
      row.style.display = '';
      var val = row.querySelector('[data-store-credit-balance-value]');
      if (val) val.textContent = formatted;
    });
  }

  function init() {
    initPopups();

    // Poll for Rise.ai globals (they load async)
    var attempts = 0;
    var poller = setInterval(function () {
      attempts++;
      if (tryFetchBalance() || attempts > 15) {
        clearInterval(poller);
      }
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:update', function () {
    requestAnimationFrame(initPopups);
  });
})();
